import Resource from '@/api/resources/Resource'
import i18n from '@/lang/i18n'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'

// Default size for server pagination in a client side grid
const defaultSize = {
    size: 1000
}
class IncidentServices extends Resource {
    async getPatientIncidents(labId, patId) {
        const response = await this.axios.get(`/incident/laboratories/${labId}/patients/${patId}/incidents`, { params: defaultSize })
        return response.data
    }
    async getPatientIncident(labId, patId, incidentId) {
        const response = await this.axios.get(`/incident/laboratories/${labId}/patients/${patId}/incidents/${incidentId}`)
        return response.data
    }
    async openPatientIncident(labId, patId, params) {
        const response = await this.axios.post(`/incident/laboratories/${labId}/patients/${patId}/incidents`, params)
        return response.data
    }
    async closePatientIncident(labId, patId, incidentId, params) {
        const response = await this.axios.put(`/incident/laboratories/${labId}/patients/${patId}/incidents/${incidentId}/close`, params)
        return response.data
    }
    async getCaseIncidents(labId, casId) {
        const response = await this.axios.get(`/incident/laboratories/${labId}/cases/${casId}/incidents`, { params: defaultSize })
        return response.data
    }
    async getCaseIncident(labId, casId, incidentId) {
        const response = await this.axios.get(`/incident/laboratories/${labId}/cases/${casId}/incidents/${incidentId}`)
        return response.data
    }
    async openCaseIncident(labId, casId, params) {
        const response = await this.axios.post(`/incident/laboratories/${labId}/cases/${casId}/incidents`, params)
        return response.data
    }
    async getCaseIncidentInformation(labId, casId) {
        const response = await this.axios.get(`/common/laboratories/${labId}/cases/${casId}`)
        return response.data
    }
    async closeCaseIncident(labId, casId, incidentId, params) {
        const response = await this.axios.put(`/incident/laboratories/${labId}/cases/${casId}/incidents/${incidentId}/close`, params)
        return response.data
    }
    async getSampleIncidents(labId, casId, samId) {
        const response = await this.axios.get(`/incident/laboratories/${labId}/cases/${casId}/samples/${samId}/incidents`, { params: defaultSize })
        return response.data
    }
    async getSampleIncident(labId, casId, samId, incidentId) {
        const response = await this.axios.get(`/incident/laboratories/${labId}/cases/${casId}/samples/${samId}/incidents/${incidentId}`)
        return response.data
    }
    async openSampleIncident(labId, casId, samId, params) {
        const response = await this.axios.post(`/incident/laboratories/${labId}/cases/${casId}/samples/${samId}/incidents`, params)
        return response.data
    }
    async getSampleIncidentInformation(labId, casId, samId) {
        const response = await this.axios.get(`/common/laboratories/${labId}/cases/${casId}/samples/${samId}`)
        return response.data
    }
    async closeSampleIncident(labId, casId, samId, incidentId, params) {
        const response = await this.axios.put(`/incident/laboratories/${labId}/cases/${casId}/samples/${samId}/incidents/${incidentId}/close`, params)
        return response.data
    }
    async getPortionIncidents(labId, casId, samId, porId) {
        const response = await this.axios.get(`/incident/laboratories/${labId}/cases/${casId}/samples/${samId}/portions/${porId}/incidents`, { params: defaultSize })
        return response.data
    }
    async getPortionIncident(labId, casId, samId, porId, incidentId) {
        const response = await this.axios.get(`/incident/laboratories/${labId}/cases/${casId}/samples/${samId}/portions/${porId}/incidents/${incidentId}`)
        return response.data
    }
    async openPortionIncident(labId, casId, samId, porId, params) {
        const response = await this.axios.post(`/incident/laboratories/${labId}/cases/${casId}/samples/${samId}/portions/${porId}/incidents`, params)
        return response.data
    }
    async getPortionIncidentInformation(labId, casId, samId, porId) {
        const response = await this.axios.get(`/common/laboratories/${labId}/cases/${casId}/samples/${samId}/portions/${porId}`)
        return response.data
    }
    async closePortionIncident(labId, casId, samId, porId, incidentId, params) {
        const response = await this.axios.put(`/incident/laboratories/${labId}/cases/${casId}/samples/${samId}/portions/${porId}/incidents/${incidentId}/close`, params)
        return response.data
    }
    async getSubportionsIncidents(labId, casId, samId, porId, supId) {
        const response = await this.axios.get(`/incident/laboratories/${labId}/cases/${casId}/samples/${samId}/portions/${porId}/subportions/${supId}/incidents`, { params: defaultSize })
        return response.data
    }
    async getSubportionIncident(labId, casId, samId, porId, supId, incidentId) {
        const response = await this.axios.get(`/incident/laboratories/${labId}/cases/${casId}/samples/${samId}/portions/${porId}/subportions/${supId}/incidents/${incidentId}`)
        return response.data
    }
    async openSubportionIncident(labId, casId, samId, porId, supId, params) {
        const response = await this.axios.post(`/incident/laboratories/${labId}/cases/${casId}/samples/${samId}/portions/${porId}/subportions/${supId}/incidents`, params)
        return response.data
    }
    async getSubportionIncidentInformation(labId, casId, samId, porId, supId) {
        const response = await this.axios.get(`/common/laboratories/${labId}/cases/${casId}/samples/${samId}/portions/${porId}/subportions/${supId}`)
        return response.data
    }
    async closeSubportionIncident(labId, casId, samId, porId, supId, incidentId, params) {
        const response = await this.axios.put(`/incident/laboratories/${labId}/cases/${casId}/samples/${samId}/portions/${porId}/subportions/${supId}/incidents/${incidentId}/close`, params)
        return response.data
    }
    async openRequestIncident(labId, requestId, params) {
        const response = await this.axios.post(`/incident/laboratories/${labId}/requests/${requestId}/incidents`, params)
        return response.data
    }

    async getRequestIncidents(labId, requestId) {
        const response = await this.axios.get(`/incident/laboratories/${labId}/requests/${requestId}/incidents`, { params: defaultSize })
        return response.data
    }

    async getRequestIncidentInformation(labId, requestId) {
        const response = await this.axios.get(`/common/laboratories/${labId}/requests/${requestId}`)
        return response.data
    }

    async getRequestIncident(labId, requestId, incidentId) {
        const response = await this.axios.get(`/incident/laboratories/${labId}/requests/${requestId}/incidents/${incidentId}`)
        return response.data
    }

    async closeRequestIncident(labId, requestId, incidentId, params) {
        const response = await this.axios.put(`/incident/laboratories/${labId}/requests/${requestId}/incidents/${incidentId}/close`, params)
        return response.data
    }

    async getFirstRequestIncidentReport(laboratoryId, requestId) {
        const incidents = await this.getRequestIncidents(laboratoryId, requestId)
        const incidentWithReport = incidents.find(incident => incident.incidentType.canBePrinted)
        if (!incidentWithReport) {
            const err = new Error('No incident report found')
            err.response = {
                data: {
                    message: i18n.t('incidents.errors.noIncidentReportFound'),
                    messageTranslated: true
                }
            }
            throw err
        }
        return this.getIncidentRequestReport(laboratoryId, requestId, incidentWithReport.incidentId, false)
    }

    getIncidentReport(laboratoryId, incidentId, entityType, entityIdHierarchy) {
        switch (entityType) {
        case COREENTITY_VALUES.GENERAL.code:
            return this.getIncidentGeneralReport(laboratoryId, incidentId, false)
        case COREENTITY_VALUES.REQUEST.code:
            return this.getIncidentRequestReport(laboratoryId, entityIdHierarchy.requestId, incidentId, false)
        case COREENTITY_VALUES.PATIENT.code:
            return this.getIncidentPatientReport(laboratoryId, entityIdHierarchy.patId, incidentId, false)
        case COREENTITY_VALUES.CASE.code:
            return this.getIncidentCaseReport(laboratoryId, entityIdHierarchy.casId, incidentId, false)
        case COREENTITY_VALUES.SAMPLE.code:
            return this.getIncidentSampleReport(laboratoryId, entityIdHierarchy.casId, entityIdHierarchy.samId, incidentId, false)
        case COREENTITY_VALUES.PORTION.code:
            return this.getIncidentPortionReport(laboratoryId, entityIdHierarchy.casId, entityIdHierarchy.samId, entityIdHierarchy.porId, incidentId, false)
        case COREENTITY_VALUES.SUBPORTION.code:
            return this.getIncidentSubportionReport(laboratoryId, entityIdHierarchy.casId, entityIdHierarchy.samId, entityIdHierarchy.porId, entityIdHierarchy.supId, incidentId, false)
        }
    }

    async getIncidentGeneralReport(labId, patId, incidentId, print) {
        return this.axios.get(`/incident/laboratories/${labId}/generalincidents/${incidentId}/report`,
            {
                headers: {
                    type: 'application/pdf'
                },
                params: {
                    encoded: print
                },
                responseType: 'arraybuffer'
            }).then(response => response.data)
    }

    async getIncidentPatientReport(labId, patId, incidentId, print) {
        return this.axios.get(`/incident/laboratories/${labId}/patients/${patId}/incidents/${incidentId}/report`,
            {
                headers: {
                    type: 'application/pdf'
                },
                params: {
                    encoded: print
                },
                responseType: 'arraybuffer'
            }).then(response => response.data)
    }

    async getIncidentRequestReport(labId, requestId, incidentId, print) {
        return this.axios.get(`/incident/laboratories/${labId}/requests/${requestId}/incidents/${incidentId}/report`,
            {
                headers: {
                    type: 'application/pdf'
                },
                params: {
                    encoded: print
                },
                responseType: 'arraybuffer'
            }).then(response => response.data)
    }

    async getIncidentCaseReport(labId, caseId, incidentId, print) {
        return this.axios.get(`/incident/laboratories/${labId}/cases/${caseId}/incidents/${incidentId}/report`,
            {
                headers: {
                    type: 'application/pdf'
                },
                params: {
                    encoded: print
                },
                responseType: 'arraybuffer'
            }).then(response => response.data)
    }

    async getIncidentSampleReport(labId, caseId, sampleId, incidentId, print) {
        return this.axios.get(`/incident/laboratories/${labId}/cases/${caseId}/samples/${sampleId}/incidents/${incidentId}/report`,
            {
                headers: {
                    type: 'application/pdf'
                },
                params: {
                    encoded: print
                },
                responseType: 'arraybuffer'
            }).then(response => response.data)
    }

    async getIncidentPortionReport(labId, caseId, sampleId, portionId, incidentId, print) {
        return this.axios.get(`/incident/laboratories/${labId}/cases/${caseId}/samples/${sampleId}/portions/${portionId}/incidents/${incidentId}/report`,
            {
                headers: {
                    type: 'application/pdf'
                },
                params: {
                    encoded: print
                },
                responseType: 'arraybuffer'
            }).then(response => response.data)
    }

    async getIncidentSubportionReport(labId, caseId, sampleId, portionId, subportionId, incidentId, print) {
        return this.axios.get(`/incident/laboratories/${labId}/cases/${caseId}/samples/${sampleId}/portions/${portionId}/subportions/${subportionId}/incidents/${incidentId}/report`,
            {
                headers: {
                    type: 'application/pdf'
                },
                params: {
                    encoded: print
                },
                responseType: 'arraybuffer'
            }).then(response => response.data)
    }

    async openGeneralIncident(labId, params) {
        const response = await this.axios.post(`/incident/laboratories/${labId}/generalincidents`, params)
        return response.data
    }

    async getGeneralIncidents(labId) {
        const response = await this.axios.get(`/incident/laboratories/${labId}/generalincidents`, { params: defaultSize })
        return response.data
    }

    async getGeneralIncident(labId, incidentId) {
        const response = await this.axios.get(`/incident/laboratories/${labId}/generalincidents/${incidentId}`)
        return response.data
    }

    async closeGeneralIncident(labId, incidentId, params) {
        const response = await this.axios.put(`/incident/laboratories/${labId}/generalincidents/${incidentId}/close`, params)
        return response.data
    }

    async paginator(filterModel, params, url) {
        const response = await this.axios.put(`/incident/${url}`, filterModel, { params })
        return response.data
    }

    async myIncidentSummary() {
        return this.axios.get(`incident/myIncidentSummary`)
            .then(response => response.data)
    }

    async getGeneralIncidentsSummary(labId) {
        return this.axios.get(`incident/laboratories/${labId}/generalIncidents/summary`)
            .then(response => response.data)
    }

    async exportTo(sectionLabel, filterModel, sortModel, columns, selectedIds, url, exportType) {
        const params = {
            page: 0,
            size: PAGINATOR_BIG_PAGE_SIZE,
            sort: sortModel,
            exportType
        }
        return this.axios.put(
            `/incident/${url}/exportToPdf`,
            { sectionLabel, filterModel, columns, entityIdentifiersRequest: { entityIdentifiers: selectedIds } },
            { params, responseType: 'arraybuffer' })
    }

    async exportSelectedIncidentsTo(sectionLabel, sortModel, columns, selectedIds, exportType) {
        const params = {
            page: 0,
            size: PAGINATOR_BIG_PAGE_SIZE,
            sort: sortModel,
            exportType
        }
        return this.axios.put(
            `/incident/reportIncidentsGrid`,
            { sectionLabel, columns, entityIdentifiersRequest: { entityIdentifiers: selectedIds } },
            { params, responseType: 'arraybuffer' })
    }
}

export default new IncidentServices()

export const COREENTITY_VALUES = {
    GENERAL: { code: 'GENERAL', name: i18n.t('entities.incident.coreEntities.general'), bgColor: 'rgba(200,200,200,1)' },
    PATIENT: { code: 'PATIENT', name: i18n.t('entities.incident.coreEntities.patient'), bgColor: 'rgba(190,10,190,1)' },
    REQUEST: { code: 'REQUEST', name: i18n.t('entities.incident.coreEntities.request'), bgColor: 'rgba(110,210,190,1)' },
    CASE: { code: 'CASE', name: i18n.t('entities.incident.coreEntities.case'), bgColor: 'rgba(10,10,190,1)' },
    SAMPLE: { code: 'SAMPLE', name: i18n.t('entities.incident.coreEntities.sample'), bgColor: 'rgba(10,160,190,1)' },
    PORTION: { code: 'PORTION', name: i18n.t('entities.incident.coreEntities.portion'), bgColor: '#66ccffff' },
    SUBPORTION: { code: 'SUBPORTION', name: i18n.t('entities.incident.coreEntities.subportion'), bgColor: '#ccccffff' }
}

export const INVALID_VALUE = { key: 'INVALID', code: 'entities.incident.coreEntities.invalid', bgColor: 'red', color: 'white' }
